<template>
  <div
    id="app"
    class="u-full-width u-relative u-overflow-hidden u-antialiased u-bg-white-off"
    :class="{'is-full': $route.meta.isFull || isMenuOpen}"
  >
    <div v-show="$route.meta.isWebGL" ref="containerWebGL" class="u-wrapper-panel"/>
    <SymbolsSvg />

    <app-header v-if="!$route.query.iframe" :isTransparent="$route.meta.isFull" @onMenuOpen="onMenuOpen" />

    <router-view v-if="globalLoaded" class="view"/>

    <transition :duration="1900" name="loader">
      <loader v-if="isTransition || !loaded || !globalLoaded" key="loader" />
    </transition>

    <div ref="containerCSS3D" class="u-wrapper-panel u-overflow-hidden u-pointer-none"/>

    <router-link class="cookie-btn" :to="{name: 'SimplePage', params: { slug: 'donnees-personnelles' }}">
      <img class="u-block u-fit-contain" src="/images/cookies.svg">
    </router-link>

    <cookie />

    <!-- Google Tag Manager -->
    <script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-5SCH6QL5');</script>
    <!-- End Google Tag Manager -->

    <!-- Google Tag Manager (noscript) -->
    <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-5SCH6QL5"
    height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
    <!-- End Google Tag Manager (noscript) -->
  </div>
</template>

<script>
import App from './App'

import { webGL } from '@/webGL/WebGL'

import AppHeader from '@/components/AppHeader'
import SymbolsSvg from '@/components/SymbolsSvg'
import Loader from '@/components/common/Loader'
import Cookie from '@/components/common/cookie'

export default {
  name: 'App',

  mixins: [App],

  components: {
    AppHeader,
    SymbolsSvg,
    Loader,
    Cookie
  },

  computed: {
    loaded () {
      return this.$store.getters['data/loaded']
    },
    globalData () {
      return this.$store.getters['data/global']
    },
    globalLoaded () {
      return this.$store.getters['data/globalLoaded']
    }
  },

  data () {
    return {
      isTransition: true,
      isMenuOpen: false,
      popin: false,
    }
  },

  created () {
    this.$store.dispatch('global/popinsSeen')
    this.$store.dispatch('data/global').then(() => {
      requestAnimationFrame(() => {
        this.isTransition = false
      })
    })

    this.$router.beforeEach(this.onTransition)
  },

  mounted () {
    this.$el.addEventListener(this.$device.pointermove, this.onPointermove)

    this.$hub.emit('webGL', this.$route.meta.isWebGL)
  },

  methods: {
    onUpdate (args) {
      if (this.$route.meta.raycast && this.mouseEvent) {
        this.$device.setRaycast(this.mouseEvent, webGL.camera)
      }

      this._onUpdate(args)
    },
    onPointermove (event) {
      this.mouseEvent = event
    },
    onTransition (to, from, next) {
      // this happens when navigate between categories
      // on projects page
      if (to.name === 'Projects' && from.name === 'Projects') {
        next()
        return
      }

      this.isTransition = true
      setTimeout(() => {
        next()
      }, 1900)
      setTimeout(() => {
        this.isTransition = false
      }, 2500)
    },
    onMenuOpen (value) {
      this.isMenuOpen = value
    }
  },

  watch: {
    $route () {
      this.$hub.emit('webGL', this.$route.meta.isWebGL)
      window.scrollTo(0,0)
      const _hsq = window._hsq = window._hsq || []
      if (_hsq) {
        _hsq.push(['setPath', this.$route.path]);
        _hsq.push(['trackPageView']);
      }
    }
  }
}
</script>

<style lang="stylus" src="./styles/theme.styl"/>

<style lang="stylus">
@import '~@/styles/settings/variables'
@import '~@/styles/settings/mixins/mq'

#app
  min-height 100vh

  &.is-full
    position fixed
    top .5px
    bottom .5px
    left 0
    right 0
    overflow hidden
    min-height auto

.cookie-btn
  position fixed
  bottom $spacings.sm
  right $spacings.sm
  background-color $colors.blue
  border-radius 50%
  padding 15px
  height 70px
  width 70px
  
  +mq($until: 'tablet')
    padding 10px
    height 50px
    width 50px
  
  
</style>
